var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUrgent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 37C2 24.0786 2 17.618 5.13166 12.9944C6.42888 11.0793 8.07926 9.42888 9.99445 8.13166C14.618 5 21.0786 5 34 5V5C46.9214 5 53.382 5 58.0055 8.13166C59.9207 9.42888 61.5711 11.0793 62.8683 12.9944C66 17.618 66 24.0786 66 37V37C66 49.9214 66 56.382 62.8683 61.0055C61.5711 62.9207 59.9207 64.5711 58.0055 65.8683C53.382 69 46.9214 69 34 69V69C21.0786 69 14.618 69 9.99445 65.8683C8.07926 64.5711 6.42888 62.9207 5.13166 61.0055C2 56.382 2 49.9214 2 37V37Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iif)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.6062 37.3605C56.6062 49.6473 46.6459 59.6077 34.3592 59.6077C22.0726 59.6077 12.1123 49.6473 12.1123 37.3605C12.1123 25.0737 22.0726 15.1133 34.3592 15.1133C46.6459 15.1133 56.6062 25.0737 56.6062 37.3605Z",
    fill: "url(#paint1_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3169 9.00195C14.3169 8.17353 14.9885 7.50195 15.8169 7.50195H52.8169C53.6453 7.50195 54.3169 8.17353 54.3169 9.00195V9.00195C54.3169 9.83038 53.6453 10.502 52.8169 10.502H15.8169C14.9885 10.502 14.3169 9.83038 14.3169 9.00195V9.00195Z",
    fill: "#FCCFD3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6919 56.875C62.2777 56.875 61.9419 56.5392 61.9419 56.125V17.625C61.9419 17.2108 62.2777 16.875 62.6919 16.875V16.875C63.1061 16.875 63.4419 17.2108 63.4419 17.625V56.125C63.4419 56.5392 63.1061 56.875 62.6919 56.875V56.875Z",
    fill: "#FBB6BC"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.56689 56.875C5.35979 56.875 5.19189 56.7071 5.19189 56.5L5.19189 17.25C5.19189 17.0429 5.35979 16.875 5.56689 16.875V16.875C5.774 16.875 5.94189 17.0429 5.94189 17.25L5.94189 56.5C5.94189 56.7071 5.774 56.875 5.56689 56.875V56.875Z",
    fill: "#FBB6BC"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4459 23.2031C6.21606 23.2031 6.03274 23.0444 6.04556 22.8522C6.12738 21.625 6.50597 17.4894 7.97626 15.4368C9.58739 13.1877 13.1893 11.3554 13.7084 11.099C13.751 11.0779 13.7972 11.0683 13.8467 11.0683V11.0683C14.1041 11.0683 14.2323 11.3321 14.0475 11.482C12.9713 12.3547 10.4745 14.4265 9.13525 15.9222C7.64728 17.584 7.00828 21.7349 6.85502 22.8967C6.83193 23.0717 6.65618 23.2031 6.4459 23.2031V23.2031Z",
    fill: "#FCCFD3"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6665 23.707C61.867 23.707 62.027 23.5417 62.0158 23.3415C61.9444 22.0631 61.6141 17.7552 60.3312 15.6171C58.9255 13.2743 55.7828 11.3657 55.3298 11.0986C55.2927 11.0766 55.2523 11.0666 55.2092 11.0666V11.0666C54.9846 11.0666 54.8727 11.3414 55.034 11.4976C55.973 12.4066 58.1515 14.5647 59.32 16.1228C60.6183 17.8538 61.1758 22.1776 61.3095 23.3878C61.3297 23.5702 61.483 23.707 61.6665 23.707V23.707Z",
    fill: "#FCCFD3"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.165 16.5192C8.11104 16.4986 8.08412 16.4384 8.10587 16.3849C8.21356 16.12 8.53794 15.3607 8.96898 14.7069C9.43377 14.0019 10.1111 13.5708 10.2751 13.473C10.2983 13.4592 10.3264 13.4572 10.3517 13.4669V13.4669C10.4192 13.4926 10.4327 13.5831 10.3759 13.6278C10.1105 13.8367 9.50685 14.3331 9.16442 14.7816C8.79365 15.2672 8.41891 16.1649 8.30078 16.4599C8.2793 16.5135 8.21897 16.5398 8.165 16.5192V16.5192Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8919 16.5192C59.9458 16.4986 59.9728 16.4384 59.951 16.3849C59.8433 16.12 59.5189 15.3607 59.0879 14.7069C58.6231 14.0019 57.9457 13.5708 57.7818 13.473C57.7586 13.4592 57.7305 13.4572 57.7052 13.4669V13.4669C57.6377 13.4926 57.6242 13.5831 57.681 13.6278C57.9464 13.8367 58.55 14.3331 58.8925 14.7816C59.2632 15.2672 59.638 16.1649 59.7561 16.4599C59.7776 16.5135 59.8379 16.5398 59.8919 16.5192V16.5192Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9052 43.973V37.7416C41.9052 36.5263 41.6188 35.3805 41.1095 34.3612C41.6301 35.3845 41.9215 36.5327 41.9215 37.7416V43.973H41.9052ZM26.6907 34.3611C26.1701 35.3844 25.8787 36.5327 25.8787 37.7416V43.973H25.895V37.7416C25.895 36.5263 26.1814 35.3804 26.6907 34.3611ZM24.7429 27.5937L26.6655 29.4495C26.7533 29.5342 26.7533 29.6736 26.6655 29.7583L25.5442 30.8406C25.4536 30.9253 25.312 30.9253 25.2243 30.8406L23.3016 28.9848C23.2595 28.9437 23.2358 28.8882 23.2358 28.8304C23.2358 28.7726 23.2595 28.7171 23.3016 28.676L24.4229 27.5937C24.4655 27.553 24.523 27.5302 24.5829 27.5302C24.6428 27.5302 24.7003 27.553 24.7429 27.5937ZM43.0629 27.5937C43.1055 27.553 43.163 27.5302 43.2229 27.5302C43.2828 27.5302 43.3403 27.553 43.3829 27.5937L44.5042 28.676C44.592 28.7607 44.592 28.8974 44.5042 28.9848L42.5816 30.8406C42.4938 30.9253 42.3494 30.9253 42.2616 30.8406L41.1403 29.7583C41.0982 29.7172 41.0745 29.6617 41.0745 29.6039C41.0745 29.546 41.0982 29.4905 41.1403 29.4495L43.0629 27.5937ZM33.9082 26.2627V25.2241H33.892V26.2627H33.9082ZM25.7736 44.9842C25.2724 44.9842 24.8675 44.5934 24.8675 44.1096V37.7416C24.8675 32.9259 28.9109 29.0231 33.9001 29.0231C38.8893 29.0231 42.9327 32.9259 42.9327 37.7416V44.1096C42.9327 44.5934 42.5278 44.9842 42.0266 44.9842H25.7736ZM33.9001 30.9909C30.0379 30.9909 26.9062 34.0137 26.9062 37.7416V43.0164H29.0298V38.3429C29.0298 38.1925 29.1573 38.0696 29.313 38.0696H30.5589C30.7146 38.0696 30.842 38.1925 30.842 38.3429V43.0164H40.894V37.7416C40.894 34.0137 37.7623 30.9909 33.9001 30.9909ZM24.8392 46.7334H42.961C43.4622 46.7334 43.8671 47.1242 43.8671 47.608V48.2639C43.8671 48.3842 43.7652 48.4826 43.6406 48.4826H24.1596C24.035 48.4826 23.9331 48.3842 23.9331 48.2639V47.608C23.9331 47.1242 24.338 46.7334 24.8392 46.7334ZM34.6929 27.2739H33.1073C32.9827 27.2739 32.8807 27.1755 32.8807 27.0553V24.4315C32.8807 24.3113 32.9827 24.2129 33.1073 24.2129H34.6929C34.8175 24.2129 34.9194 24.3113 34.9194 24.4315V27.0553C34.9194 27.1755 34.8175 27.2739 34.6929 27.2739Z",
    fill: "url(#paint2_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iif",
    x: 10.6123,
    y: 14.218,
    width: 46.9939,
    height: 46.2849,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.895261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.776867 0 0 0 0 0.0831333 0 0 0 0 0.141291 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.5,
    dy: -0.895261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.270588 0 0 0 0 0.356863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect3_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 7.76551,
    y: 0.950565,
    width: 53.1028,
    height: 16.1028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.27569,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f",
    x: 57.3683,
    y: 12.3014,
    width: 10.6472,
    height: 49.1472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.28681,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f",
    x: 0.618284,
    y: 12.3014,
    width: 9.89722,
    height: 49.1472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.28681,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f",
    x: 3.24492,
    y: 8.26836,
    width: 13.6899,
    height: 17.7348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f",
    x: 52.1578,
    y: 8.26641,
    width: 12.6586,
    height: 18.2405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f",
    x: 7.0686,
    y: 12.0898,
    width: 4.37025,
    height: 5.80306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f",
    x: 56.6179,
    y: 12.0898,
    width: 4.37025,
    height: 5.80306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d",
    x: 23.2358,
    y: 24.2129,
    width: 23.3342,
    height: 26.7697,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.793151 0 0 0 0 0.106849 0 0 0 0 0.164384 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 34.3596,
    y1: 5,
    x2: 34.3596,
    y2: 70.2247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D60113"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 32.337,
    y1: 14.102,
    x2: 35.8764,
    y2: 58.0908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F84356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8253D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 33.9029,
    y1: 24.2129,
    x2: 34.3594,
    y2: 48.4826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE6E8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUrgent);
export default __webpack_public_path__ + "static/media/icon_urgent.c286e1fb7c252183c1eed8d619619dc9.svg";
export { ForwardRef as ReactComponent };